<template>
  <base-wrapper>
    <div class="space-y-4">
      <div class="flex justify-end gap-2">
        <base-input label="Dari Tanggal">
          <base-input
            :shadow="false"
            type="date"
            v-model="filter.fromDate"
            @change="loadContacts"
          />
        </base-input>
        <base-input label="Sampai Tanggal">
          <base-input
            :shadow="false"
            type="date"
            debounce
            v-model="filter.toDate"
            @change="loadContacts"
          />
        </base-input>
        <base-input label="Status">
          <base-select
            :shadow="false"
            :options="[
              { key: 'null', label: 'Semua', value: null },
              { key: 'read', label: 'Dibaca', value: true },
              { key: 'unread', label: 'Belum Dibaca', value: false },
            ]"
            v-model="filter.readStatus"
            @change="loadContacts"
          ></base-select>
        </base-input>
        <base-input label="Tipe">
          <base-select
            :shadow="false"
            :options="[
              { key: 'null', label: 'Semua', value: null },
              ...Object.entries(officeTypes).map(([key, value]) => ({
                key,
                label: value,
                value: key,
              })),
            ]"
            v-model="filter.officeType"
            @change="loadContacts"
          ></base-select>
        </base-input>
        <base-input label="Pencarian">
          <base-input
            placeholder="Cari nomor (+62)"
            :shadow="false"
            type="text"
            debounce
            v-model="filter.searchPhoneNumber"
            @native-input="loadContacts"
          />
        </base-input>
        <base-button :loading="loadingExport.visible" @click="onExport">
          <p v-if="loadingExport.visible">{{ loadingExport.text }}</p>
          <template v-else>
            <Icon icon="heroicons:arrow-down-tray" class="h-4 w-4" />
            Export
          </template>
        </base-button>
      </div>

      <datatable
        :columns="[
          { id: 'customer', name: 'Customer' },
          { id: 'office_tipe', name: 'Tipe' },
          { id: 'message', name: 'Message' },
          { id: 'status', name: 'Status', theadClass: 'text-center' },
        ]"
        :total="contacts.meta.page.total"
        :perPage="contacts.meta.page.perPage"
        :currentPage="contacts.meta.page.currentPage"
        @pagechanged="onChangePageContacts"
      >
        <template #tbody="{ classes }">
          <tr
            v-for="contact in contacts.data"
            :key="contact.id"
            :class="[classes.tr, 'cursor-pointer bg-white hover:bg-gray-50']"
            @click="onDetailContact(contact)"
          >
            <td :class="classes.td">
              <p class="text-sm">{{ contact.attributes.name }}</p>
              <p
                :class="[
                  'text-gray-900',
                  contact.attributes.last_chat_direction === 'receive' &&
                  contact.attributes.last_chat_status !== 'read'
                    ? 'font-bold'
                    : 'font-semibold',
                ]"
              >
                {{ contact.attributes.phone_number }}
              </p>
            </td>
            <td :class="classes.td">
              <p v-if="contact.attributes.office_type">
                {{ officeTypes[contact.attributes.office_type] }}
                <span v-if="contact.attributes.office_code"
                  >/ {{ contact.attributes.office_code }}</span
                >
              </p>
            </td>
            <td :class="classes.td">
              <div class="flex items-center gap-2">
                <div
                  v-if="
                    contact.attributes.last_chat_direction === 'receive' &&
                    contact.attributes.last_chat_status !== 'read'
                  "
                  class="rounded-full bg-green-600"
                  style="width: 10px; height: 10px"
                ></div>
                <div>
                  <p class="text-xs">
                    {{ contact.attributes.last_chat_sent_at | formatDate }}
                  </p>
                  <p
                    :class="[
                      'text-gray-900',
                      contact.attributes.last_chat_direction === 'receive' &&
                      contact.attributes.last_chat_status !== 'read'
                        ? 'font-bold'
                        : '',
                    ]"
                  >
                    {{ contact.attributes.last_chat_message | truncate(100) }}
                  </p>
                </div>
              </div>
            </td>
            <td :class="classes.td">
              <Icon
                v-if="contact.attributes.last_chat_direction === 'send'"
                :icon="getStatusBadge(contact.attributes.last_chat_status).icon"
                :class="[
                  'mx-auto h-5 w-5',
                  getStatusBadge(contact.attributes.last_chat_status).iconColor,
                ]"
              />
            </td>
          </tr>
        </template>
      </datatable>
    </div>

    <base-modal
      :showing="detailContact.visible"
      :with-padding="false"
      @close="detailContact.visible = false"
    >
      <base-card
        :with-style="false"
        :title="detailContact.name"
        :description="detailContact.phoneNumber"
        :classes="{
          header: 'p-6',
        }"
      >
        <template #title>
          <div class="flex items-center gap-2">
            <h3
              v-if="detailContact.name"
              class="text-lg font-bold leading-6 text-gray-900"
            >
              {{ detailContact.name }}
            </h3>
            <base-badge
              v-if="detailContact.officeType"
              color="indigo"
              size="sm"
            >
              {{ officeTypes[detailContact.officeType] }}
              <span v-if="detailContact.officeCode"
                >/ {{ detailContact.officeCode }}</span
              >
            </base-badge>
          </div>
        </template>
        <div class="border-t">
          <div
            id="amad"
            style="max-height: 600px; overflow-y: auto"
            class="space-y-4 p-6"
            ref="chatHistory"
          >
            <div class="flex items-center justify-center">
              <base-button
                v-if="chats.data.length < chats.meta.page.total"
                color="white"
                size="sm"
                :loading="loadingMoreChat"
                @click="onLoadMoreChat"
              >
                Muat lebih banyak
                <Icon icon="heroicons:arrow-up" />
              </base-button>
            </div>
            <div v-for="chat in chatHistories" :key="chat.id" class="space-y-1">
              <div
                v-if="chat.attributes.user_email === 'NASA System'"
                class="space-y-1"
              >
                <div
                  :class="[
                    'fit ml-auto flex max-w-sm items-center gap-2 rounded-md p-4 text-xs',
                    checksMessageTypeError(chat.attributes.message_type)
                      ? 'bg-red-100 text-red-700'
                      : 'bg-blue-100 text-gray-900',
                  ]"
                >
                  <Icon
                    v-if="checksMessageTypeError(chat.attributes.message_type)"
                    icon="heroicons:exclamation-triangle"
                    class="h-4 w-4"
                  />
                  <p>
                    <i
                      >{{ chat.attributes.sent_at | formatDate }}
                      {{
                        checksMessageTypeError(chat.attributes.message_type)
                          ? getMessageTypeErrorMessage(
                              chat.attributes.message_type
                            )
                          : chat.attributes.message
                      }}</i
                    >
                  </p>
                  <Icon
                    :icon="getStatusBadge(chat.attributes.status).icon"
                    :class="[
                      'h-4 w-4',
                      getStatusBadge(chat.attributes.status).iconColor,
                    ]"
                  />
                </div>
                <p class="text-right text-xs text-gray-500">
                  {{ chat.attributes.user_email }}
                </p>
              </div>
              <template v-else>
                <div
                  :class="[
                    'fit max-w-sm space-y-1 rounded-md p-4',
                    chat.attributes.direction === 'send'
                      ? 'ml-auto bg-green-100'
                      : 'bg-gray-100',
                  ]"
                >
                  <p class="text-sm text-gray-900">
                    {{ chat.attributes.message }}
                  </p>
                  <div class="flex items-center justify-between gap-2">
                    <p class="text-xs text-gray-700">
                      {{ chat.attributes.sent_at | formatDate }}
                    </p>
                    <Icon
                      v-if="chat.attributes.direction === 'send'"
                      :icon="getStatusBadge(chat.attributes.status).icon"
                      :class="[
                        'h-4 w-4',
                        getStatusBadge(chat.attributes.status).iconColor,
                      ]"
                    />
                  </div>
                </div>
                <p
                  :class="[
                    'text-xs text-gray-500',
                    chat.attributes.direction === 'send'
                      ? 'text-right'
                      : 'text-left',
                  ]"
                >
                  {{ chat.attributes.user_email }}
                </p>
              </template>
            </div>
          </div>
          <form
            class="flex items-center gap-2 border-t px-6 py-4"
            @submit.prevent="onSubmitReply"
          >
            <base-input
              type="text"
              fullwidth
              :shadow="false"
              placeholder="Ketik pesan balasan"
              :disabled="detailContactExpired"
              v-model="replyMessage"
            />
            <base-button v-if="!detailContactExpired" :disabled="!replyMessage">
              <Icon icon="heroicons:paper-airplane-solid" class="h-4 w-4" />
            </base-button>
            <base-button v-else type="button" @click="onOpenSendExpireChat"
              >Kirim dengan Device Lain</base-button
            >
          </form>
        </div>
      </base-card>
    </base-modal>

    <base-confirm
      size="max-w-lg"
      confirm-text="Kirim"
      :visible="sendExpireChat.visible"
      @close="sendExpireChat.visible = false"
      :icon="false"
      type="success"
      title="Kirim Pesan"
      message="Kirim pesan balasan dengan device lain"
      @confirmed="onConfirmSendExpireChat"
    >
      <template #content>
        <base-input inset label="Pilih Device">
          <base-select
            inset
            expand
            :options="deviceOptions"
            v-model="sendExpireChat.deviceId"
          ></base-select>
        </base-input>
        <base-input
          inset
          label="Pesan Balasan"
          tag="textarea"
          placeholder="Masukkkan pesan balasan"
          rows="5"
          v-model="sendExpireChat.message"
        />
      </template>
    </base-confirm>

    <loading
      v-if="
        loading || loadingDevices || loadingBotStatus || loadingSendExpireChat
      "
    />
  </base-wrapper>
</template>

<script>
import { requestMixin } from '../../../mixins/request/request';
import BaseModal from '../../../components/base/BaseModal.vue';
import BaseConfirm from '../../../components/base/BaseConfirm.vue';
import { mapGetters } from 'vuex';
import { nextTick } from 'vue';
import dayjs from 'dayjs';
import { mapActions } from 'vuex';
import { downloadFileUrl } from '../../../services/utils.service';

export default {
  mixins: [requestMixin],
  components: {
    BaseModal,
    BaseConfirm,
  },
  data() {
    return {
      botRunning: false,
      loading: true,
      loadingMoreChat: false,
      loadingBotStatus: false,
      loadingDevices: false,
      loadingSendExpireChat: false,
      loadingExport: {
        visible: false,
        text: null,
      },
      detailContact: {
        visible: false,
        id: null,
        name: null,
        phoneNumber: null,
        officeType: null,
        officeCode: null,
      },
      devices: [],
      contacts: {
        data: [],
        meta: {
          page: {},
        },
      },
      chats: {
        data: [],
        meta: {
          page: {},
        },
      },
      replyMessage: null,
      filter: {
        readStatus: null,
        searchPhoneNumber: null,
        officeType: null,
        fromDate: dayjs().format('YYYY-MM-DD'),
        toDate: dayjs().format('YYYY-MM-DD'),
      },
      sendExpireChat: {
        deviceId: null,
        message: null,
        visible: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
      getChannelName: 'auth/getChannelName',
    }),
    chatHistories() {
      return [...this.chats.data].reverse();
    },
    detailContactExpired() {
      if (!this.chats.data.length) {
        return true;
      }

      const receiveChats = this.chats.data.filter(
        (chat) => chat.attributes.direction === 'receive'
      )

      if (!receiveChats.length) {
        return true
      }

      const lastSentAt = receiveChats[0].attributes.sent_at;

      return dayjs().diff(dayjs(lastSentAt), 'hour') > 23;
    },
    deviceOptions() {
      return [
        { key: 'null', value: null, label: 'Pilih Device' },
        ...(this.botRunning
          ? this.devices
              .filter((device) => device.connected)
              .map((device) => ({
                key: device.device_id,
                value: device.device_id,
                label: `${device.name} - ${device.phone_number}`,
              }))
          : []),
      ];
    },
    officeTypes() {
      return {
        pusat: 'Pusat',
        kantor_pelayanan: 'Kantor Pelayanan',
        stockist_center: 'Stockist Center',
        stockist: 'Stockist',
        member: 'Mitra Usaha',
        umum: 'Umum',
      };
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async checkBotStatus() {
      this.loadingBotStatus = true;

      const [res, err] = await this.request(`/api/v1/whatsapp-bot/status`);

      if (!err) {
        this.botRunning = res.running;
      }

      this.loadingBotStatus = false;
    },
    async checkExportStatus() {
      const [res, err] = await this.request(
        '/api/v1/users/-actions/check-job-status',
        {
          params: {
            type: 'export_whatsapp_chat',
          },
        }
      );

      if (!err) {
        const { running } = res;

        if (running) {
          this.startLoadingExport('Sedang diproses');
        }
      }
    },
    checksMessageTypeError(type) {
      return [
        'request_pin_invalid',
        'request_pin_notfound',
        'request_pin_phone_mismatch',
      ].includes(type);
    },
    getMessageTypeErrorMessage(type) {
      return {
        request_pin_invalid: 'Request PIN: Format tidak valid',
        request_pin_notfound: 'Request PIN: Kode tidak ditemukan',
        request_pin_phone_mismatch: 'Request PIN: No. Telp tidak sesuai',
      }[type];
    },
    async getDevices() {
      this.loadingDevices = true;

      const [res, err] = await this.request(`/api/v1/whatsapp-bot/devices`);

      if (!err) {
        this.devices = res;
      }

      this.loadingDevices = false;
    },
    getStatusBadge(status) {
      return {
        pending: {
          text: 'Pending',
          icon: 'mdi:clock-outline',
          iconColor: 'text-gray-600',
        },
        sent: {
          text: 'Terkirim',
          icon: 'mdi:check',
          iconColor: 'text-gray-600',
        },
        delivered: {
          text: 'Diterima',
          icon: 'mdi:check-all',
          iconColor: 'text-gray-600',
        },
        read: {
          text: 'Dibaca',
          icon: 'mdi:check-all',
          iconColor: 'text-blue-600',
        },
      }[status];
    },
    listenToBroadcast() {
      const channel = this.$pusher.subscribe('private-WhatsappChat');
      const userChannel = this.$pusher.channel(this.getChannelName);

      userChannel.bind(
        'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
        this.onExportStatusUpdated
      );

      channel.bind('WhatsappChatCreated', (e) => {
        const direction = e.model.direction;

        if (direction === 'send') {
          this.chats.data = this.chats.data.filter(
            (chat) => chat.id !== 'pending'
          );
        }

        const chatContact =
          direction === 'send' ? e.to_contact : e.from_contact;
        const chatContactId = chatContact.id.toString();

        const chatContactIndex = this.contacts.data.findIndex(
          (contact) => contact.id === chatContactId
        );

        if (chatContactIndex !== -1) {
          this.contacts.data[chatContactIndex].attributes.last_chat_id =
            e.model.id;
          this.contacts.data[chatContactIndex].attributes.last_chat_message =
            e.model.message;
          this.contacts.data[chatContactIndex].attributes.last_chat_status =
            e.model.status;
          this.contacts.data[chatContactIndex].attributes.last_chat_sent_at =
            e.model.sent_at;
          this.contacts.data[chatContactIndex].attributes.last_chat_direction =
            e.model.direction;

          if (
            this.detailContact.visible &&
            this.detailContact.id === chatContactId
          ) {
            this.chats.data.unshift({
              id: e.model.id.toString(),
              type: 'whatsapp-chats',
              attributes: {
                message: e.model.message,
                status: e.model.status,
                sent_at: e.model.sent_at,
                direction: e.model.direction,
                user_email: e.model.user_email,
              },
            });
          }
        } else {
          this.contacts.data.unshift({
            id: chatContactId,
            type: 'whatsapp-contacts',
            attributes: {
              phone_number: chatContact.phone_number,
              name: chatContact.name,
              last_chat_id: e.model.last_chat_id,
              last_chat_message: e.model.message,
              last_chat_status: e.model.status,
              last_chat_sent_at: e.model.sent_at,
              last_chat_direction: e.model.direction,
            },
          });
        }

        this.contacts.data.sort(
          (a, b) => b.attributes.last_chat_id - a.attributes.last_chat_id
        );
      });
      channel.bind('WhatsappChatUpdated', (e) => {
        const direction = e.model.direction;
        const contactId =
          e.model[
            direction === 'send' ? 'to_contact_id' : 'from_contact_id'
          ].toString();

        const chatContactIndex = this.contacts.data.findIndex(
          (contact) => contact.id === contactId
        );

        if (chatContactIndex !== -1) {
          this.contacts.data[chatContactIndex].attributes.last_chat_status =
            e.model.status;

          if (
            this.detailContact.visible &&
            this.detailContact.id === contactId
          ) {
            const chatIndex = this.chats.data.findIndex(
              (chat) => chat.id === e.model.id.toString()
            );

            if (chatIndex !== -1) {
              this.chats.data[chatIndex].attributes.status = e.model.status;
            }
          }
        }
      });
    },
    async loadContacts(params) {
      this.loading = true;

      const [res, err] = await this.request(`/api/v1/whatsapp-contacts`, {
        params: {
          'fields[whatsapp-contacts]':
            'phone_number,name,last_chat_message,last_chat_id,last_chat_status,last_chat_sent_at,last_chat_direction,office_type,office_code',
          'filter[exclude_admin]': true,
          'filter[search_phone_number]': this.filter.searchPhoneNumber,
          'filter[last_chat_read_status]': this.filter.readStatus,
          'filter[office_type]': this.filter.officeType,
          'filter[has_chat_between_date]': [
            this.filter.fromDate,
            this.filter.toDate,
          ]
            .filter((date) => !!date)
            .join(','),
          'filter[has_chat]': true,
          sort: '-last_chat_id',
          'page[size]': 5,
          ...params,
        },
      });

      if (!err) {
        this.contacts = res;
      }

      this.loading = false;
    },
    async loadChat(params, append = false) {
      if (append) {
        this.loadingMoreChat = true;
      } else {
        this.loading = true;
      }

      const prevScrollTop = append ? this.$refs.chatHistory.scrollTop : 0;
      const prevScrollHeight = append ? this.$refs.chatHistory.scrollHeight : 0;

      const [res, err] = await this.request(`/api/v1/whatsapp-chats`, {
        params: {
          'filter[contact_id]': this.detailContact.id,
          'fields[whatsapp-chats]':
            'message,message_type,sent_at,status,direction,user_email',
          sort: '-id',
          'page[size]': 10,
          ...params,
        },
      });

      if (!err) {
        if (append) {
          this.chats.data = [...this.chats.data, ...res.data];
          this.chats.meta = res.meta;
        } else {
          this.chats = res;
        }

        await nextTick();

        if (!append) {
          this.scrollBottomChatHistory();
        } else {
          const newScrollHeight = this.$refs.chatHistory.scrollHeight;

          this.scrollChatHistoryTo(
            prevScrollTop + (newScrollHeight - prevScrollHeight)
          );
        }
      }

      if (append) {
        this.loadingMoreChat = false;
      } else {
        this.loading = false;
      }
    },
    async markChatAsRead(contactId) {
      const contactIndex = this.contacts.data.findIndex(
        (contact) => contact.id === contactId
      );

      this.contacts.data[contactIndex].attributes.last_chat_status = 'read';

      await this.request(
        `/api/v1/whatsapp-contacts/${contactId}/-actions/mark-admin-read`,
        {
          method: 'patch',
        }
      );
    },
    onDetailContact(contact) {
      this.detailContact.visible = true;
      this.detailContact.id = contact.id;
      this.detailContact.phoneNumber = contact.attributes.phone_number;
      this.detailContact.name = contact.attributes.name;
      this.detailContact.officeCode = contact.attributes.office_code;
      this.detailContact.officeType = contact.attributes.office_type;

      this.loadChat();
      this.markChatAsRead(contact.id);
    },
    onChangePageContacts(page) {
      this.loadContacts({
        'page[number]': page,
      });
    },
    async onSubmitReply() {
      this.chats.data.unshift({
        id: 'pending',
        attributes: {
          message: this.replyMessage,
          sent_at: new Date(),
          status: 'pending',
          direction: 'send',
          user_email: this.me.email,
        },
      });

      await nextTick();

      this.scrollBottomChatHistory();

      const sendChats = this.chatHistories.filter(
        (chat) => chat.attributes.direction === 'receive'
      );
      const chat = sendChats[sendChats.length - 1];

      await this.request(`/api/v1/whatsapp-chats/${chat.id}/-actions/reply`, {
        method: 'post',
        data: {
          message: this.replyMessage,
        },
      });

      this.replyMessage = null;
    },
    onLoadMoreChat() {
      this.loadChat(
        {
          'page[number]': this.chats.meta.page.currentPage + 1,
        },
        true
      );
    },
    onOpenSendExpireChat() {
      this.sendExpireChat.deviceId = null;
      this.sendExpireChat.message = null;
      this.sendExpireChat.visible = true;
    },
    async onConfirmSendExpireChat() {
      this.loadingSendExpireChat = true;

      const [, err] = await this.request(
        `/api/v1/whatsapp-contacts/${this.detailContact.id}/-actions/send-broadcast`,
        {
          method: 'post',
          data: {
            device_id: this.sendExpireChat.deviceId,
            message: this.sendExpireChat.message,
          },
        }
      );

      if (err) {
        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(err),
        });
      } else {
        this.createAlert({
          status: 'success',
          data: 'Berhasil membalas pesan dengan device',
        });

        this.sendExpireChat.deviceId = null;
        this.sendExpireChat.message = null;
        this.sendExpireChat.visible = false;
      }

      this.loadingSendExpireChat = false;
    },
    async onExport() {
      this.startLoadingExport('Mengirim ke server');

      const [, err] = await this.request(
        '/api/v1/whatsapp-chats/-actions/export',
        {
          method: 'post',
          data: {
            from_date: this.filter.fromDate,
            to_date: this.filter.toDate,
          },
        }
      );

      if (err) {
        this.createAlert({
          data: 'Gagal download data chat',
          status: 'error',
        });

        this.stopLoadingExport();
      } else {
        this.loadingExport.text = 'Sedang Diproses';
      }
    },
    onExportStatusUpdated(e) {
      if (e.type === 'App\\Notifications\\WhatsappChatExported') {
        if (e.status === 'failed') {
          this.stopLoadingExport();

          this.createAlert({
            data: 'Gagal download data chat',
            status: 'error',
          });
        } else if (e.status === 'success') {
          this.stopLoadingExport();

          downloadFileUrl(e.file_url, 'whatsapp-chat.csv', { blank: true });
        }
      }
    },
    stopListenToBroadCast() {
      this.$pusher.unsubscribe('private-WhatsappChat');
    },
    scrollBottomChatHistory() {
      this.$refs.chatHistory.scrollTop = this.$refs.chatHistory.scrollHeight;
    },
    scrollChatHistoryTo(int) {
      this.$refs.chatHistory.scrollTop = int;
    },
    startLoadingExport(text) {
      this.loadingExport.text = text;
      this.loadingExport.visible = true;
    },
    stopLoadingExport() {
      this.loadingExport.visible = false;
      this.loadingExport.text = null;
    },
  },
  created() {
    this.loadContacts();
    this.listenToBroadcast();
    this.checkBotStatus();
    this.checkExportStatus();
    this.getDevices();
  },
  destroyed() {
    this.stopListenToBroadCast();
  },
};
</script>
